import { render, staticRenderFns } from "./SocialShareButton.vue?vue&type=template&id=2c79ab54&scoped=true"
import script from "./SocialShareButton.vue?vue&type=script&lang=js"
export * from "./SocialShareButton.vue?vue&type=script&lang=js"
import style0 from "./SocialShareButton.vue?vue&type=style&index=0&id=2c79ab54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c79ab54",
  null
  
)

export default component.exports